import React from 'react';

import { DialogActions, Paragraph, TextButton } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import YesAndNo from '../../../Widgets/YesAndNo';
import { SECTION_8_HOUSING_VOUCHER } from '../../../../constants';
import InlineTooltip from '../../../Widgets/InlineTooltip';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function Section8HousingVoucher({ section, setSectionValues }: Props): JSX.Element {
  function onNoVoucher(): void {
    setSectionValues({
      [SECTION_8_HOUSING_VOUCHER.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesVoucher(): void {
    setSectionValues({
      [SECTION_8_HOUSING_VOUCHER.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <Paragraph fontType="h6" marginBottom="xs">
        Will the tenant use a{' '}
        <InlineTooltip
          tooltipBodyText={
            <>
              The Housing Choice voucher program (Section 8) is a subsidy program administered by local housing agencies
              to help low-income families find safe housing. Landlords must go through an approval process to accept
              Housing Choice Vouchers.
              <DialogActions>
                <TextButton
                  as="a"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.hud.gov/program_offices/public_indian_housing/programs/hcv/landlord"
                >
                  Learn more
                </TextButton>
              </DialogActions>
            </>
          }
          closeWith={['blur']}
          openWith={['focus', 'click', 'mouseEnter']}
          shouldCloseOnOutsideClick
        >
          Housing Choice voucher
        </InlineTooltip>{' '}
        (i.e., a Section 8 voucher)?
      </Paragraph>
      <YesAndNo
        yesHandler={onYesVoucher}
        noHandler={onNoVoucher}
        yesActive={section.getFieldValue(SECTION_8_HOUSING_VOUCHER.FIELD_NAME.IS_ENABLED)}
      />
    </>
  );
}
